import {Component, OnInit, OnDestroy, OnChanges, Input} from '@angular/core';
import {StoreService} from '../../shared/store/store.service';
import {AlertService} from '../../shared/alert/alert.service';
import {EventService} from '../../shared/event/event.service';
import {AutoRefreshService} from '../../shared/auto-refresh/auto-refresh.service';
// import { CognitoAuthService } from '../../shared/auth/cognito.service';

declare const _;

@Component({
    selector: 'alerts-table',
    templateUrl: './alerts-table.component.html',
    styleUrls: ['./alerts-table.component.css'],
    // providers: [ StoreService ]
    providers: []
})
export class AlertsTableComponent implements OnChanges, OnInit, OnDestroy {

    @Input() timePeriod = '';
    @Input() displayRanges = true; // default is to show the ranges
    @Input() deviceIP = '';
    @Input() threatType = '';

    alerts: any[ ] = [];
    alertsParams: any[ ] = [
        {
            timePeriod: 'a',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'h',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'd',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'w',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'm',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'q',
            ip: null,
            param3: null,
        },
        {
            timePeriod: 'y',
            ip: null,
            param3: null,
        }
    ];
    subscriptions: any = {
        autoRefresh: null,
        alerts: null,
        events: null,
    };

    timePeriods = ['a', 'h', 'd', 'w', 'm', 'q', 'y'];
    timePeriodIndex = 3;

    events: any[ ] = [];

    isAlertsDataLoading: boolean;
    isAlertsDataError: boolean;
    allEventIds: string;
    expandAlert: number;

    isEventsDataLoading: boolean;
    isEventsDataError: boolean;

    /*
     maxEventDataCallRetries = 3;
     eventsDataSubscription;
     */

    risks = ['INFO', 'LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
    riskClasses = ['bg-risk-info', 'bg-risk-low', 'bg-risk-medium', 'bg-risk-high', 'bg-risk-critical'];
    icons = ['bomb', 'bug', 'sliders', 'crosshairs', 'info-circle'];

    sortByFields = [['date'], ['strategy', 'date'], ['method', 'date'], ['risk', 'date'], ['source', 'date'], ['destination', 'date']];
    sortIndex = 0;
    sortAscending = false;

    // constructor(private store: StoreService, private alertService: AlertService, private eventService: EventService, private authService: CognitoAuthService) {
    constructor(private store: StoreService,
                private autoRefreshService: AutoRefreshService,
                private alertService: AlertService,
                private eventService: EventService) {

        this.isAlertsDataLoading = true;
        this.isAlertsDataError = false;
        this.allEventIds = '';
        this.expandAlert = null;

        this.isEventsDataLoading = true;
        this.isEventsDataError = false;

        /*
         self.autoRefreshService.autoRefreshCounter.subscribe(function (counter) {
         self.refresh();
         });
         */
    }

    ngOnInit() {

        const self = this;

        self.subscriptions.timePeriod = self.store.onChange('timePeriod', function (timePeriod) {

            console.log('qqq Alerts for timePeriod = ', timePeriod);

            self.changeTimePeriod(timePeriod);
        });

        self.subscriptions.autoRefresh = self.store.onChange('autoRefresh', function (val) {

            console.log('>>>>>>>> Refreshing alerts! >>>>>>>> ', val);

            self.refresh();
        });
    }

    ngOnChanges(changes) {
        if ('threatType' in changes) {
            if (typeof changes.threatType !== undefined) {
                this.threatType = changes.threatType.currentValue;
                this.refresh();
            }
        }
    }

    refresh(silent = true) {
        this.getAlerts(this.timePeriodIndex, true, silent);
    }

    getAlerts(alertsParamsIndex, forceFetchAlertsFromAPI = false, silent = false) {

        const self = this;

        if (!silent) {
            self.isAlertsDataLoading = true;
        }

        const params = self.alertsParams[alertsParamsIndex];
        // inject the IP quietly here
        if (this.deviceIP) {
            params.ip = this.deviceIP;
        }

        // TODO: Update backend to accept threatType as a parameter and return alerts for that threatType (e.g. System Compromise) and then uncomment the if-statement below
        /*
        if (this.threatType) {
            params.threatType = this.threatType;
        }
        */

        self.alertService.getAlerts(params, forceFetchAlertsFromAPI).subscribe(function (alerts) {

            self.allEventIds = '';


            if (self.threatType in ['0', '1', '2', '3', '4']) {
                self.alerts = alerts.filter(alert => alert.type == self.threatType)
            } else {
                self.alerts = alerts;
            }

            self.alerts.forEach(function (alert) {
                self.allEventIds += alert.event_ids ? (self.allEventIds ? ',' : '') + alert.event_ids : '';
            });

            // self.store.update('alerts', alerts);
            self.isAlertsDataLoading = false;
            self.isAlertsDataError = false;

            self.getEventsForAlerts(forceFetchAlertsFromAPI);

            // console.dir(self.alerts);

        }, function (err) {

            console.log('Error in getting alerts. Called from alerts-table.component.ts');
            console.log(err);

        });

    }

    getEventsForAlerts(forceFetchEventsFromAPI = false) {

        const self = this;

        const params = {
            eventIds: self.allEventIds,
            areEventsForAlerts: true
        };

        self.eventService.getEvents(params, forceFetchEventsFromAPI).subscribe(function (events) {

            self.isEventsDataLoading = false;
            self.isEventsDataError = false;

            let adjEvents = [];
            events.forEach(function (event) {
                event.event_ts = event.event_ts.substring(0, 19).replace('T', ' ');
                adjEvents[event.event_id] = event;
            });

            self.events = adjEvents;
            // self.store.update('events', adjEvents);

            self.alerts.map(function (alert) {

                const ids = alert.event_ids.split(',');

                alert.events = ids.map(function (eventId) {
                    return adjEvents[eventId];
                });
            });
        }, function (err) {

            console.log('Error in getting events for alerts. Called from alerts-table.component.ts');
            console.log(err);

        });
    }

    sortBy(i) {

        // console.log('Sorting alerts by ', this.sortByFields[i], '...');

        if (this.sortIndex === i) {
            this.sortAscending = !this.sortAscending;
        } else {
            this.sortAscending = false;
        }

        this.sortIndex = i;
        this.alerts = _.sortBy(this.alerts, this.sortByFields[i]);
        if (!this.sortAscending) {
            this.alerts = _.reverse(this.alerts);
        }
    }

    changeTimePeriod(t) {
        const index = this.timePeriods.indexOf(t);
        if (index > -1) {
            this.timePeriodIndex = index;
            this.getAlerts(index);
        }
    }

    ngOnDestroy() {

        // console.log('onDestroy called on AlertsTableComponent');

        const self = this;

        Object.keys(self.subscriptions).forEach(function (key) {
            if (self.subscriptions[key]) {
                self.subscriptions[key].unsubscribe();
            }
        });
    }

    /*
     getEvents(idToken, event_ids, customer) {
     const self = this;

     self.eventsDataSubscription = self.eventService.getEvents(event_ids).subscribe(function(events) {
     // console.log(event_ids);
     self.isEventsDataLoading = false;
     self.isEventsDataError = false;

     let adjEvents = [ ];
     events.forEach(function(event){
     event.event_ts = event.event_ts.substring(0, 19).replace('T', ' ');
     adjEvents[event.event_id] = event;
     });

     self.events = adjEvents;
     self.store.update('events', adjEvents);

     self.alerts.map(function(alert){
     // console.log('alert: '+alert.event_ids);
     const ids = alert.event_ids.split(',');
     // console.log(ids);
     alert.events = ids.map(function(e){
     // ar eObj = {};
     // Obj[e] = adjEvents[e];
     // console.log('event: '+e);
     // console.log(eObj);
     return adjEvents[e];
     });
     });

     }, function (err) {

     console.log('Error in getEvents() of dashboard.component');

     self.events = [];
     self.isEventsDataLoading = false;
     self.isEventsDataError = true;

     self.eventsDataSubscription.unsubscribe();
     --self.maxEventDataCallRetries;
     if (self.maxEventDataCallRetries > 0) {
     self.getEvents(idToken, event_ids, customer);
     }
     });
     }
     */

}



// WEBPACK FOOTER //
// /app/src/app/components/alerts-table/alerts-table.component.ts